module.exports = __webpack_public_path__ + "static/media/mcrcsm_logo.1fccf340.png";